import { useState, useEffect } from "react";
import OrganisationLayout from "../../components/organisation/layout/OrganisationLayout";
import { Formik } from "formik";
import {
  BaseButton,
  BaseInput,
  BaseSelect,
  BasePhoneInput,
} from "../../components/base";
import { genderTypes, titles } from "../../data/utils";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store";
import {
  createCustomerAction,
  fetchAllCustomers,
} from "../../store/slices/customer/action";
import { Platform } from "../../enums/plaftorm.enum";
import { toast } from "react-toastify";
import { saveBeneficiaryDetails } from "../../store/slices/customer";
import {
  BookingBeneficiaryDetails,
  CustomerProfile,
} from "../../store/slices/customer/types";
import { BiArrowToLeft, BiSolidArrowToLeft } from "react-icons/bi";
import { getMainProfile } from "../../utils/helper";

function AddNewBookerAccount() {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [showAddNewCustomer, setShowAddNewCustomer] = useState<boolean>(false);
  const [selectedCustomer, setSelectedCustomer] = useState<CustomerProfile>({
    id: "",
    name: "",
  });
  const [initialValues, setInitialValues] = useState({
    lastName: "",
    email: "",
    dateOfBirth: "",
    firstName: "",
    mobile: "",
  });

  const [formValue, setFormValue] = useState({
    gender: {
      id: "",
      name: "",
    },
    title: {
      id: "",
      name: "",
    },
    mobile: {
      value: "",
    },
  });
  type ErrorMsg = {
    genderError: string;
    mobileError: string;
    titleError: string;
  };
  const [errorMsg, setErrorMsg] = useState<ErrorMsg>({
    genderError: "",
    mobileError: "",
    titleError: "",
  });
  const dispatch = useAppDispatch();
  const router = useNavigate();

  const { currentOrganisationAccount } = useAppSelector(
    (state) => state.authReducer
  );

  const selectGender = (obj: { id: string; name: string }) => {
    setFormValue({ ...formValue, gender: obj });
    setErrorMsg({ ...errorMsg, genderError: "" });
  };

  const selectTitle = (obj: { id: string; name: string }) => {
    setFormValue({ ...formValue, title: obj });
    setErrorMsg({ ...errorMsg, titleError: "" });
  };

  const selectPhone = (obj: any) => {
    setFormValue((prevState) => ({
      ...prevState,
      mobile: obj,
    }));
    setErrorMsg((prevState) => ({
      ...prevState,
      mobileError: "",
    }));
  };
  type FormTypeValues = {
    email: string;
    dateOfBirth: string;
    firstName: string;
    lastName: string;
  };
  const validateDetails = (values: FormTypeValues) => {
    let errors: any = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.email) {
      errors.email = "Email cannot be blank";
    } else if (!regex.test(values.email)) {
      errors.email = "Invalid email format";
    }
    if (!values.dateOfBirth) {
      errors.dateOfBirth = "Date of birth cannot be blank";
    }
    if (!values.firstName) {
      errors.firstName = "Firstname cannot be blank";
    }
    if (!values.lastName) {
      errors.lastName = "Lastname  cannot be blank";
    }

    if (formValue.mobile?.value?.length < 13) {
      errors.mobileError = "Please enter a valid mobile number";
      setErrorMsg((prevState) => ({
        ...prevState,
        mobileError: "Please enter a valid mobile number",
      }));
    }

    if (!formValue?.gender?.id) {
      errors.gender = "Please select your gender";
      setErrorMsg((prevState) => ({
        ...prevState,
        genderError: "Please select your gender",
      }));
    }

    return errors;
  };

  const onCreateNewCustomer = async (
    values: FormTypeValues,
    { resetForm }: any
  ) => {
    try {
      const newCustomer = {
        ...values,
        dateOfBirth: new Date(values.dateOfBirth),
        title: formValue?.title?.name,
        gender: formValue?.gender?.id,
        mobile: formValue?.mobile?.value,
        createdFromPlatform: Platform.OrganisationDashboard,
        createdByOrganisationId:
          currentOrganisationAccount?.organisationId || "",
      };

      setIsProcessing(true);

      const res = await dispatch(createCustomerAction(newCustomer));
      if (res.payload?.status === 201) {
        setIsProcessing(false);
        const newAccount = res?.payload?.payload;
        const { title, gender, mobile } = newCustomer;
        dispatch(
          saveBeneficiaryDetails({
            ...values,
            email: values?.email.toLowerCase(),
            title,
            gender,
            mobile,
            userId: newAccount.userId,
            accountId: newAccount?.accountId,
          })
        );

        router(`/dashboard/customers/${newAccount?.accountId}`);
      }

      if (res.payload?.statusCode >= 400 && res.payload?.statusCode < 500) {
        setIsProcessing(false);
        return toast.error(res.payload?.message);
      }
      if (res.payload?.statusCode >= 500) {
        setIsProcessing(false);
        return toast.error("An unexpected error has occured! please try again");
      }
    } catch (error) {
      setIsProcessing(false);
      toast.error("An unexpected error has occured! please try again");
    }
  };
  return (
    <>
      <OrganisationLayout>
        <div className="px-3 lg:w-2/3 lg:px-12 mt-8">
          <div className="mb-4">
            <h1 className="text-[#525256] text-[1.25rem] font-[700] mb-2">
              Add New Booker Account{" "}
            </h1>
            <p className="text-[#525256] text-[0.875rem] font-[400]">
              Fill the details of the new account
            </p>
          </div>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            onSubmit={onCreateNewCustomer}
            validate={validateDetails}
            // innerRef={formikRef}
          >
            {(formik) => {
              const {
                values,
                errors,
                touched,
                handleSubmit,
                handleChange,
                handleBlur,
              } = formik;
              return (
                <form onSubmit={handleSubmit}>
                  <div className="sm:grid sm:grid-cols-2 sm:gap-5">
                    <BaseInput
                      id={"firstName"}
                      value={values.firstName}
                      label="First Name"
                      name={"firstName"}
                      type="firstName"
                      hasError={errors?.firstName && touched.firstName}
                      change={handleChange}
                      blur={handleBlur}
                      bodyStyles="mb-6 sm:mb-2"
                      errorMsg={errors.firstName}
                    />
                    <BaseInput
                      id={"lastName"}
                      value={values.lastName}
                      label="Last Name"
                      name={"lastName"}
                      type="lastName"
                      hasError={errors.lastName && touched.lastName}
                      change={handleChange}
                      blur={handleBlur}
                      bodyStyles="mb-6 sm:mb-2"
                      errorMsg={errors.lastName}
                    />
                    <BaseSelect
                      value={formValue.gender}
                      label="Gender"
                      name={"gender"}
                      styleClass="mb-6"
                      hasError={!!errorMsg.genderError}
                      errorMsg={errorMsg.genderError}
                      onChange={selectGender}
                      options={genderTypes}
                      selectKey="name"
                      textClass={""}
                      filter={false}
                      showClear={false}
                      inputId={""}
                    />
                    <BaseSelect
                      value={formValue.title}
                      label="Title"
                      name={"title"}
                      styleClass="mb-6"
                      hasError={!!errorMsg.titleError}
                      errorMsg={errorMsg.titleError}
                      onChange={selectTitle}
                      options={titles}
                      selectKey="name"
                      textClass={""}
                      filter={true}
                      showClear={false}
                      inputId={""}
                    />
                    <BaseInput
                      id={"dateOfBirth"}
                      value={values.dateOfBirth}
                      label="Date of Birth"
                      name={"dateOfBirth"}
                      type="date"
                      hasError={errors.dateOfBirth && touched.dateOfBirth}
                      change={handleChange}
                      blur={handleBlur}
                      bodyStyles="mb-6"
                      errorMsg={errors.dateOfBirth}
                    />
                    <BaseInput
                      id={"email"}
                      value={values.email}
                      label="Email"
                      name={"email"}
                      type="email"
                      hasError={errors.email && touched.email}
                      change={handleChange}
                      blur={handleBlur}
                      bodyStyles="mb-6"
                      errorMsg={errors.email}
                    />
                    <div>
                      <BasePhoneInput
                        value={formValue.mobile?.value}
                        label="Phone Number"
                        id="mobile"
                        blur={handleBlur}
                        selectPhone={selectPhone}
                        hasError={!!errorMsg.mobileError && touched.mobile}
                        errorMsg={errorMsg.mobileError}
                      />
                    </div>
                  </div>
                  <div className="lg:w-1/3 pt-4">
                    <BaseButton
                      text="Proceed"
                      styles="w-full sm:w-1/2 lg:w-full h-[53px] rounded-[70px] font-[500] !text-white font-medium border-0 !text-[1rem] textbrandColor"
                      type="submit"
                      variant="primary"
                      processing={isProcessing}
                    />
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
      </OrganisationLayout>
    </>
  );
}

export default AddNewBookerAccount;
